import React from 'react'

import { Container } from './styles'

const News: React.FC = () => {
  return (
    <Container>
      <span>Assunto do momento no Brasil</span>
      <strong>Essa coisa linda ta funcionando</strong>
    </Container>
  )
}

export default News
